const HistoryColumns = [
  {
    title: "Change DateTime",
    field: "LogAt",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY hh:mm A",
    editor: "date",
    width: "auto",
    show: true,
  },

  {
    title: "Department", //"DepartmentDivSec",
    field: "Dept" || "fromDepartment", //"frDeptDivSec",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
  {
    title: "Edit Date",
    field: "UpdatedAt",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY hh:mm A",
    editor: "date",
    width: "auto",
    show: true,
  },
  // {
  //   title: "Entered Date",
  //   field: "dateEntered",
  //   locked: false,
  //   filter: "date",
  //   format: "MM/DD/YYYY hh:mm A",
  //   editor: "date",
  //   width: "auto",
  //   show: true,
  // },
  // {
  //   title: "Final Post",
  //   field: "finalPost",
  //   locked: false,
  //   filter: "text",
  //   width: "auto",
  //   show: true,
  // },
  {
    title: "Effective Date",
    field: "Effective_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY hh:mm A",
    editor: "date",
    width: "auto",
    show: true,
  },
  {
    title: "Termination Date",
    field: "TerminationDate",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY hh:mm A",
    editor: "date",
    width: "auto",
    show: true,
  },
  {
    title: "Legal",
    field: "LegalAuthority", //"legal",
    locked: false,
    filter: "text",
    width: "auto",
    show: true,
  },
];

export default HistoryColumns;
